import { AccessBlock } from "modules/session/access-links/AccessBlock";
import { AccessStatus } from "modules/session/access-links/access-link-actions";
import { Button, Classes, Dialog, Divider, Icon, InputGroup, MenuItem } from "@blueprintjs/core"
import { PlanrPopover } from "modules/common/components/planr/popover/Popover"
import { Switch } from "@blueprintjs/core"
import { ItemPredicate, ItemRenderer } from "@blueprintjs/select"
import { Field, FieldProps, Form, Formik, FormikHelpers, getIn } from "formik"
import { observer } from "mobx-react"
import { getSnapshot } from "mobx-state-tree"
import { EmployerName } from "modules/common/components/employer/EmployerName"
import { DatePicker } from "modules/common/components/form/DatePicker"
import moment from "moment"
import { DATE_TIME_FORMAT } from "modules/common/constants"
import { StandardFormButtons } from "modules/common/components/form/StandardFormButtons"
import { StandardFormInput } from "modules/common/components/form/StandardFormInput"
import { MoneyInput } from "modules/common/components/money/MoneyInput"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { PlanRDndUploader } from "modules/common/components/planr/dndUploader/FileDndUploader"
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"
import { EMPTY_OBJECT_ID } from "modules/common/constants"
import { isNewlyCreated } from "modules/common/models/entity"
import { MimeTypes } from "modules/common/services/files"
import { buildOptions, DefaultSelectedOption, filterItemPredicate, RendererProps, renderSingleOption, SelectFactory, SimpleSelect } from "modules/common/services/form/select"
import { texts } from "modules/common/texts"
import { OwnSpendingsWidget } from "modules/main/components/own-spendings/OwnSpendingsWidget"
import { OwnSpendingsWidgetStoreType } from "modules/main/models/own-spendings-store"
import { Constants } from "modules/root/models/constants"
import { EmployeePositionDictionaryType } from "modules/spending/departments/models/employee-position-dictionary"
import React from "react"
import { Prompt } from "modules/common/components/routing/Prompt";
import { buildPatchEmployer } from "../../../../common/services/form/values"
import { EmployerType, fields } from "../../models/employer"
import { EmployeeListType } from "../../models/employer-list"
import ChildDetails from "./ChildDetails"
import styles from "./EmployerDetails.module.scss"
import { EmployerDocuments } from "./EmployerDocuments"
import { TransferDialog } from "./TransferDialog"
import EmployerSchema, { employerLabels } from "./validation"
import { PositionDialog } from "modules/spending/departments/components/details/PositionDialog"
import { PositionsDictionaryDialog } from "modules/spending/departments/components/PositionsDictionaryDialog"
import { Asterisk } from "modules/common/components/form/Asterisk"
import { ProjectPortfolioDictionaryType } from 'modules/dictionaries/project-portfolios/models/project-portfolio-dictionary'

const PositionSelect = SelectFactory<PositionSelectItem>()

/**
 * Enter в карточке сотрудника не сохраняет форму: полей много, и случайное нажатие
 * в любом из них отправляло всю карточку. Сохранение — только кнопкой.
 * Многострочные поля Enter обрабатывают сами
 */
const preventSubmitOnEnter = (e: React.KeyboardEvent<HTMLFormElement>) => {
  const target = e.target as HTMLElement

  if (e.key === "Enter" && target?.tagName !== "TEXTAREA") {
    e.preventDefault()
  }
}
export const ACCEPT = [MimeTypes.jpeg, MimeTypes.png].join(",")

const old = new Date(1920, 1, 1)
const labels = employerLabels()
const schema = EmployerSchema()

class Employer extends React.Component<EmployerDetailsProps, EmployerDetailsState> {
  private formProps: FormikHelpers<any> | null = null;
  private isFired: boolean = false;
  constructor(props: EmployerDetailsProps) {
    super(props)
    this.state = {
      showChildrenDialog: false,
      childId: "",
      avatar: "",
      showChild: false,
      showAvatarLoad: false,
      showGrades: false,
      showChangePosition: false,
      showReturn: false,
      positionDialog: null,
      positionsDictionary: false,
      gradeGuid: props.employer?.employerPositions?.[0]?.gradeGuid || null,
      accessOpen: false,
      accessStatus: null,
    }
  }
  async componentDidMount() {
    const { employerList, employerId, employer } = this.props

    if (employerId !== EMPTY_OBJECT_ID) {
      employerList.loadProjects(employerId)
      this.loadAccessStatus()
      if (employer) {
        this.setState({ avatar: employer.avatar ? employer.avatar : "", gradeGuid: employer.employerPositions?.[0]?.gradeGuid || null })
        this.isFired = employer.fireDate ? true : false

      }
    }
  }

  /**
   * Состояние входа - для отметки на кнопке «Данные для входа» внизу карточки. После перезагрузки страницы карточка
   * открывается раньше, чем догрузится сотрудник: с пустым id не спрашиваем, а когда id появится - спросим
   */
  accessStatusFor = ""

  loadAccessStatus = () => {
    const employer = this.props.employer
    if (!employer || !employer.id || employer.id === EMPTY_OBJECT_ID || employer.id === this.accessStatusFor) {
      return
    }

    const id = employer.id
    this.accessStatusFor = id
    if (this.state.accessStatus) {
      this.setState({ accessStatus: null })
    }
    employer.loadAccess().then((status: AccessStatus | null) => {
      if (this.props.employer?.id === id) {
        this.setState({ accessStatus: status })
      }
    })
  }

  componentDidUpdate(prevProps: EmployerDetailsProps) {
    // сотрудник догрузился или сменился (модель обновляется на месте - сравниваем с запомненным id)
    this.loadAccessStatus()

    const prevGradeGuid = prevProps.employer?.employerPositions?.[0]?.gradeGuid
    const currentGradeGuid = this.props.employer?.employerPositions?.[0]?.gradeGuid

    // Обновляем если значение изменилось или было null, а теперь появилось
    if (prevGradeGuid !== currentGradeGuid) {
      this.setState({ gradeGuid: currentGradeGuid || null })
    }

    // Также обновляем avatar если изменился
    if (prevProps.employer?.avatar !== this.props.employer?.avatar) {
      this.setState({ avatar: this.props.employer?.avatar || "" })
    }
  }
  /** точка на кнопке «Данные для входа»: ждёт сохранения / отключён / может входить / пароля нет */
  loginDotClass = (pendingPassword: string | undefined) => {
    const status = this.state.accessStatus
    if (pendingPassword) {
      return styles.loginDotPending
    }
    if (status?.blocked) {
      return styles.loginDotBlocked
    }
    return status?.hasPassword ? styles.loginDotOn : styles.loginDotOff
  }

  /** должность поправили из карточки — обновить список */
  onPositionSaved = async () => {
    this.setState({ positionDialog: null })
    await this.props.positions.load()
  }

  /** в справочнике добавили должность — выбрать её в карточке */
  onPositionCreated = async (id: string) => {
    await this.props.positions.load()
    this.formProps?.setFieldValue(fields.positionId, id, true)
  }

  render() {
    const { employer, onSaved, positions, canChange, employerId, portfolios } = this.props
    const { baseUrl, spendings, orderAccess, employerList, documentNotes } = this.props
    const isNewEmployer = isNewlyCreated(employerId)
    const employerPositions = buildPositionsOptions(positions)
    const initial = getFormValues(
      employer,
      isNewEmployer ? this.props.presetDepartmentId : "",
      isNewEmployer ? this.props.presetPositionId : ""
    )
    const departmentOptions = buildDepartmentOptions(this.props.departments)
    const gipDepartmentId = Constants.gipDepartmentId

    const portfolioOptions = buildOptions(null, portfolios.portfolios, true)
    // организация сотрудника меняется переводом - с датой приёма в новую организацию и сохранением стажа
    const portfolioLocked = !isNewEmployer && !!employer.portfolioId
    const sinceText = (value: string | null) => (value ? moment(value, DATE_TIME_FORMAT).format("DD.MM.YYYY") : "")
    // дата начала стажа - первой: целиком срок в поле не помещается. Стаж, сброшенный сегодня, - только дата
    const seniorityText = employer.seniorityDate
      ? [`с ${sinceText(employer.seniorityDate)}`, employer.workingPeriod.trim()].filter(Boolean).join(", ")
      : employer.workingPeriod

    return (
      <div className={styles.details}>
        {this.state.positionsDictionary && (
          <PositionsDictionaryDialog
            onClose={() => {
              this.setState({ positionsDictionary: false })
              this.props.positions.load()
            }}
            onCreated={this.onPositionCreated}
          />
        )}
        {this.state.positionDialog !== null && (
          <PositionDialog
            positionId={this.state.positionDialog}
            onClose={() => this.setState({ positionDialog: null })}
            onSaved={this.onPositionSaved}
          />
        )}
        <Formik
          initialValues={initial}
          enableReinitialize={true}
          validationSchema={schema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (!canChange) {
              return
            }

            const patch = buildPatchEmployer(initial, values, ["documentBlocks", "changeGrade", "changeGradeSince"])
            // новый сотрудник из дерева: подразделение заполнено заранее, в разницу оно не попадает
            if (isNewEmployer && (values as any)[fields.departmentId]) {
              patch[fields.departmentId] = (values as any)[fields.departmentId]
            }
            if (!patch[fields.departmentId]) {
              delete patch[fields.departmentId]
            }
            const succsessfull = await employer.save(patch)
            setSubmitting(false)

            if (succsessfull) {
              resetForm()
              onSaved("") // employer.id
            }
          }}
        >
          {(formProps) => {
            this.formProps = formProps
            const { dirty, values } = formProps
            // const grade = employer.employerPositions?.[0]?.gradeGuid
            // «Доступен как ГИП» — по подразделению сотрудника (от должности оно больше не зависит)
            const selectedDepartmentId: string = (values as any)[fields.departmentId] || ""

            return (
              <Form autoComplete="off" onKeyDown={preventSubmitOnEnter}>
                <Prompt when={dirty && canChange} message={texts.messages.leaveConfiramtion} />
                <Dialog
                  icon="info-sign"
                  title="Дети"
                  canEscapeKeyClose={true}
                  canOutsideClickClose={false}
                  isOpen={this.state.showChildrenDialog}
                  onClose={this.toggleChildrenDialog}
                  style={{ width: `620px` }}
                  backdropClassName="standard"
                >
                  <div className={Classes.DIALOG_BODY}>
                    <div>
                      {employer.children && employer.children.length > 0 && (
                        <div className={styles.childrenRow} style={{ fontWeight: "bold" }}>
                          <div className={styles.childrenRowName}>Имя</div>
                          <div className={styles.childrenRowBDay}>Дата рождения</div>
                          <div className={styles.childrenRowDel}></div>
                        </div>
                      )}

                      {employer.children &&
                        employer.children.map((child) => (
                          <div
                            key={child.guid}
                            className={styles.childrenRow}
                            onDoubleClick={() => {
                              this.setState({ childId: child.guid })
                              this.toggleChild()
                            }}
                          >
                            <div className={styles.childrenRowName}>{child.name}</div>
                            <div className={styles.childrenRowBDay}>{child.birthday}</div>
                            <div className={styles.childrenRowDel}>
                              <GeneralIcon
                                type="general-trash"
                                style={{ color: "red", cursor: "pointer" }}
                                onClick={() => employer.removeChild(child.guid)}
                              />
                            </div>
                          </div>
                        ))}
                      <div className={styles.checkers} style={{ marginTop: "20px" }}>
                        <PlanrButton type="secondary" onClick={this.toggleChild}>
                          Добавить
                        </PlanrButton>
                        <PlanrButton style={{ marginLeft: "10px" }} type="graybtn" onClick={this.toggleChildrenDialog}>
                          Закрыть
                        </PlanrButton>
                      </div>
                    </div>
                  </div>
                </Dialog>
                <Dialog
                  icon="info-sign"
                  title=""
                  canEscapeKeyClose={true}
                  canOutsideClickClose={false}
                  isOpen={this.state.showChild}
                  onClose={this.toggleChild}
                  style={{ width: `600px` }}
                  backdropClassName="standard"
                >
                  {
                    <ChildDetails
                      canChange={canChange}
                      childId={this.state.childId}
                      employer={employer}
                      hideDialog={this.toggleChild}
                    />
                  }
                </Dialog>

                <div className={Classes.DIALOG_BODY}>
                  <div>
                    <div className={styles.avatar}>
                      <Field name={fields.avatar}>
                        {({ form, field }: FieldProps) => {
                          const onFileSelected = async (file: File) => {
                            var reader = new FileReader()
                            // const updateAvatar = (str: any) => {
                            //     this.setState({ avatar: str });
                            // };
                            reader.readAsDataURL(file)
                            reader.onload = () => {
                              form.setFieldValue(field.name, reader.result)
                              form.setFieldTouched(field.name, true)
                              this.toggleAvatarLoad()
                            }
                            reader.onerror = function (error) { }
                          }

                          const onRemove = () => {
                            form.setFieldValue(field.name, "")
                            form.setFieldTouched(field.name, true)
                          }

                          return (
                            <div className={styles.avatar}>
                              <Dialog
                                icon="info-sign"
                                title="Загрузка фото сотрудника"
                                canEscapeKeyClose={true}
                                canOutsideClickClose={true}
                                isOpen={this.state.showAvatarLoad}
                                onClose={this.toggleAvatarLoad}
                                style={{ width: `500px` }}
                                backdropClassName="standard"
                              >
                                <div className={Classes.DIALOG_BODY}>
                                  <div className={styles.avatarLoad}>
                                    <div>Примечания: </div>

                                    <ul>
                                      <li>Цветная фотография (ТОЛЬКО ЛИЦО);</li>
                                      <li>
                                        Ваше лицо не должно быть скрыто очками, шляпой или иными предметами, должно быть
                                        этичным;
                                      </li>
                                      <li>Размер изображения не более 5 мб;</li>
                                      <li>Формат – JPEG, PNG;</li>
                                      <li>Разрешение: 120х120px.</li>
                                    </ul>
                                    <div>
                                      <PlanRDndUploader accept={ACCEPT} onFileSelected={onFileSelected} />
                                    </div>
                                  </div>
                                </div>
                              </Dialog>
                              <span className={styles.avatarText}>Фото</span>

                              <div style={{ marginRight: "18px" }}>
                                {field.value ? (
                                  <PlanrPopover
                                    interactionKind="hover"
                                    className="planr-column-selector"
                                    content={
                                      <div className={styles.bigAvatarContainer}>
                                        {field.value ? (
                                          <img src={field.value} alt={"avatar"} className={styles.bigAvatar} />
                                        ) : (
                                          <Icon icon="user" size={120} />
                                        )}
                                      </div>
                                    }
                                  >
                                    <img src={field.value} alt={"avatar"} className={styles.avatarImage} />
                                  </PlanrPopover>
                                ) : (
                                  <Icon icon="user" size={55} />
                                )}
                              </div>
                              <PlanrButton
                                type="lightgreenish"
                                size="small"
                                icon="general-plus-big"
                                onClick={this.toggleAvatarLoad}
                              />
                              <PlanrButton type="secondary" size="small" icon="general-trash" onClick={onRemove} />
                            </div>
                          )
                        }}
                      </Field>
                    </div>
                    <StandardFormInput name={fields.name} schema={schema} small={true} className="planr-form-input">
                      {({ field }) => (
                        <InputGroup
                          id={field.name}
                          {...field}
                          className="planr-default-input"
                          autoComplete="off"
                          data-lpignore="true"
                          small
                          disabled={!canChange}
                        />
                      )}
                    </StandardFormInput>
                    <StandardFormInput name={fields.portfolioId} schema={schema} label={"Организация"} small={true} className="planr-form-input">
                      {({ field, form }) => {
                        const option = portfolioOptions[field.value]

                        return (
                          <div className={`${Classes.INPUT_GROUP}`}>
                            <SimpleSelect
                              className={`full-width-select ${Classes.FILL}`}
                              filterable={false}
                              activeItem={option}
                              inputProps={field}
                              items={Object.values(portfolioOptions)}
                              itemRenderer={renderSingleOption}
                              onItemSelect={(i: SelectItem) => {
                                form.setFieldValue(fields.portfolioId, i.id)
                                form.setFieldTouched(fields.portfolioId, true)
                              }}
                              disabled={portfolios.isEmpty || !canChange || portfolioLocked}

                            >
                              <DefaultSelectedOption option={option} />
                            </SimpleSelect>
                          </div>
                        )
                      }}
                    </StandardFormInput>
                    <StandardFormInput
                      name={fields.positionId}
                      schema={schema}
                      small={true}
                      className="planr-form-input"
                      required={false}
                      label={
                        <span className={styles.positionLabel}>
                          <span>
                            {labels[fields.positionId]}
                            <Asterisk isRequired={true} />
                          </span>
                          {canChange && this.props.canOpenPositions && (
                            <span className={styles.positionButtons}>
                              <PlanrButton
                                type="graybtn"
                                size="tiny"
                                round
                                icon="general-plus"
                                title="Справочник должностей: выбрать или добавить"
                                onClick={() => this.setState({ positionsDictionary: true })}
                              />
                              <PlanrButton
                                type="graybtn"
                                size="tiny"
                                round
                                icon="general-edit"
                                title="Открыть выбранную должность"
                                disabled={!(values as any)[fields.positionId]}
                                onClick={() => this.setState({ positionDialog: (values as any)[fields.positionId] })}
                              />
                            </span>
                          )}
                        </span>
                      }
                    >
                      {({ field, form }) => {
                        const option = employerPositions[field.value]

                        return (
                          <div className={`${Classes.INPUT_GROUP} ${styles.positionSelect}`}>
                            <PositionSelect
                              className={`planr-default-input ${Classes.FILL}`}
                              popoverProps={{ popoverClassName: styles.wrapMenu }}
                              filterable={true}
                              itemPredicate={filterPositionPredicate}
                              activeItem={option}
                              inputProps={{
                                ...field,
                                placeholder: labels[field.name],
                              }}
                              items={Object.values(employerPositions)}
                              itemRenderer={PositionOptionRenderer}
                              onItemSelect={(item) => {
                                form.setFieldValue(field.name, item.id, true)
                              }}
                              // должность работающего сотрудника меняется только переводом
                              disabled={!canChange || positions.isEmpty || !isNewEmployer}
                            >
                              <DefaultSelectedOption
                                option={option}
                                empty={positions.isEmpty}
                                render={SelectedPositionRenderer}
                              />
                            </PositionSelect>
                          </div>
                        )
                      }}
                    </StandardFormInput>
                    {departmentOptions.length > 0 && (
                      <StandardFormInput
                        name={fields.departmentId}
                        schema={schema}
                        small={true}
                        className="planr-form-input"
                      >
                        {({ field, form }) => {
                          const option = departmentOptions.find((d) => d.id === field.value)

                          return (
                            <div className={`${Classes.INPUT_GROUP}`}>
                              <SimpleSelect
                                className={`full-width-select ${Classes.FILL}`}
                                popoverProps={{ popoverClassName: styles.wrapMenu }}
                                filterable={true}
                                itemPredicate={filterItemPredicate}
                                activeItem={option}
                                inputProps={{ ...field, placeholder: "Поиск подразделения" }}
                                items={departmentOptions}
                                itemRenderer={renderSingleOption}
                                onItemSelect={(i: SelectItem) => {
                                  form.setFieldValue(field.name, i.id)
                                  form.setFieldTouched(field.name, true)
                                }}
                                // подразделение работающего сотрудника меняется переводом (с датой)
                                disabled={!canChange || !isNewEmployer}
                              >
                                <DefaultSelectedOption option={option} />
                              </SimpleSelect>
                            </div>
                          )
                        }}
                      </StandardFormInput>
                    )}
                    {employer.employePositionId && canChange && !employer.fired && (
                      <PlanrButton
                        type="secondary"
                        size="small"
                        onClick={() => {
                          this.setState({
                            showChangePosition: !this.state.showChangePosition,
                          })
                        }}
                        style={{ marginLeft: "160px", width: "275px", marginBottom: "10px", height: "auto", paddingTop: "3px", paddingBottom: "3px" }}
                      >
                        <span className={styles.transferButton}>
                          Перевод
                          <span className={styles.transferKinds}>организация, подразделение, должность</span>
                        </span>
                      </PlanrButton>
                    )}
                    {employer.employerPositions &&
                      employer?.employerPositions[0] &&
                      employer?.employerPositions[0].grades &&
                      employer?.employerPositions[0].grades.length > 0 && (
                        <>
                          <StandardFormInput
                            name={fields.changeGrade}
                            schema={schema}
                            small={true}
                            className="planr-form-input"
                            label="Ранг"
                          >
                            {({ field, form }) => {
                              let employerGrades = employer.employerPositions &&
                                employer?.employerPositions[0] &&
                                employer?.employerPositions[0].grades ? [...employer?.employerPositions[0].grades] : []

                              const gradeItems = [
                                { id: "null", label: "Без ранга - 0%" }, // Используем строку "null" вместо null
                                ...employerGrades
                                  .filter((grade) => grade.guid !== null)
                                  .map((grade) => ({ id: grade.guid as string, label: `${grade.gradeName} - ${grade.percent}%` }))
                              ]
                              const currentGradeGuid = this.state.gradeGuid ?? this.props.employer?.employerPositions?.[0]?.gradeGuid ?? null

                              const selectedOption = gradeItems.find((item) => {
                                if (!currentGradeGuid || currentGradeGuid === "null") {
                                  return item.id === "null"
                                }
                                return item.id === currentGradeGuid
                              }) || gradeItems[0]


                              return (
                                <div className={`${Classes.INPUT_GROUP}`}>
                                  <SimpleSelect
                                    className={`full-width-select ${Classes.FILL}`}
                                    activeItem={selectedOption}
                                    items={gradeItems}
                                    filterable={false}
                                    itemRenderer={renderSingleOption}
                                    onItemSelect={(item: SelectItem) => {
                                      this.setState({ gradeGuid: item.id })
                                      form.setFieldValue(field.name, item.id, true)
                                      form.setFieldTouched(field.name, true)
                                    }}
                                    disabled={!canChange || employerGrades.length === 0}
                                  >
                                    <DefaultSelectedOption
                                      option={selectedOption}
                                      empty={employerGrades.length === 0}

                                    />
                                  </SimpleSelect>
                                </div>
                              )
                            }}
                          </StandardFormInput>
                          {(() => {
                            const originalGradeGuid = this.props.employer?.employerPositions?.[0]?.gradeGuid || "null"
                            const selectedGradeGuid = this.state.gradeGuid ?? originalGradeGuid
                            const gradeChanged = selectedGradeGuid !== originalGradeGuid
                            const gradeSince = employer?.employerPositions?.[0]?.gradeSince
                            const hasGrade = !!selectedGradeGuid && selectedGradeGuid !== "null"

                            if (gradeChanged && hasGrade) {
                              return (
                                <StandardFormInput
                                  name={fields.changeGradeSince}
                                  schema={schema}
                                  small={true}
                                  className="planr-form-input"
                                  label="Ранг с какого числа"
                                >
                                  {({ field, form }) => (
                                    <div className={`${Classes.INPUT_GROUP}`}>
                                      <DatePicker
                                        clasName="planr-default-input"
                                        value={field.value}
                                        onChange={(date) => {
                                          form.setFieldValue(field.name, date)
                                          form.setFieldTouched(field.name, true)
                                        }}
                                        disabled={!canChange}
                                        small
                                      />
                                    </div>
                                  )}
                                </StandardFormInput>
                              )
                            }

                            if (!gradeChanged && hasGrade && gradeSince) {
                              return (
                                <div style={{ fontSize: "11px", opacity: 0.7, marginTop: "-4px", marginBottom: "6px" }}>
                                  {`Ранг с ${moment(gradeSince).format("DD.MM.YYYY")}`}
                                </div>
                              )
                            }

                            return null
                          })()}
                        </>

                      )}

                    <Dialog
                      icon="info-sign"
                      title="Повторное трудоустройство"
                      canEscapeKeyClose={true}
                      canOutsideClickClose={false}
                      isOpen={this.state.showReturn}
                      onClose={() => {
                        this.setState({ showReturn: false })
                      }}
                      style={{ width: `620px` }}
                      backdropClassName="standard"
                    >
                      <div className={Classes.DIALOG_BODY}>
                        <div>
                          <StandardFormInput name={fields.changeHireDate} schema={schema} className="planr-form-input">
                            {({ field, form }) => {
                              return (
                                <div className={`${Classes.INPUT_GROUP} `}>
                                  <DatePicker
                                    clasName="planr-default-input"
                                    value={field.value}
                                    onChange={(date) => {
                                      form.setFieldValue("hireDate", date)
                                      form.setFieldTouched("hireDate", true)
                                      form.setFieldValue(field.name, date)
                                      form.setFieldTouched(field.name, true)
                                    }}
                                    disabled={!canChange}
                                    small
                                  />
                                </div>
                              )
                            }}
                          </StandardFormInput>
                          <StandardFormInput
                            name={fields.positionId}
                            schema={schema}
                            small={true}
                            className="planr-form-input"
                          >
                            {({ field, form }) => {
                              const option = employerPositions[field.value]

                              return (
                                <div className={`${Classes.INPUT_GROUP}`}>
                                  <PositionSelect
                                    className={`planr-default-input ${Classes.FILL}`}
                                    filterable={true}
                                    itemPredicate={filterPositionPredicate}
                                    activeItem={option}
                                    inputProps={{
                                      ...field,
                                      placeholder: labels[field.name],
                                    }}
                                    items={Object.values(employerPositions)}
                                    itemRenderer={PositionOptionRenderer}
                                    onItemSelect={(item) => {
                                      form.setFieldValue(field.name, item.id, true)
                                    }}
                                    disabled={!canChange || positions.isEmpty}
                                  >
                                    <DefaultSelectedOption
                                      option={option}
                                      empty={positions.isEmpty}
                                      render={SelectedPositionRenderer}
                                    />
                                  </PositionSelect>
                                </div>
                              )
                            }}
                          </StandardFormInput>
                          <StandardFormInput
                            name={fields.salary}
                            schema={schema}
                            small={true}
                            className="planr-form-input"
                          >
                            {({ field, form }) => (
                              <MoneyInput
                                className="planr-default-input"
                                id={field.name}
                                autoComplete="off"
                                data-lpignore="true"
                                value={field.value}
                                onMoneyChange={(money) => {
                                  form.setFieldValue(field.name, money.value, true)
                                }}
                              />
                            )}
                          </StandardFormInput>

                          <StandardFormInput
                            name={fields.bonus}
                            schema={schema}
                            small={true}
                            className="planr-form-input"
                          >
                            {({ field, form }) => (
                              <MoneyInput
                                className="planr-default-input"
                                id={field.name}
                                autoComplete="off"
                                data-lpignore="true"
                                value={field.value}
                                onMoneyChange={(money) => {
                                  form.setFieldValue(field.name, money.value, true)
                                }}
                              />
                            )}
                          </StandardFormInput>
                        </div>
                        <div className={styles.infoText}>Не забудьте нажать кнопку Сохранить в карточке сотрудника</div>
                        <div className={styles.checkers} style={{ marginTop: "20px" }}>
                          <PlanrButton
                            type="greenish"
                            onClick={() => {
                              this.setState({
                                showReturn: !this.state.showReturn,
                              })
                            }}
                            size="small"
                          >
                            Сохранить
                          </PlanrButton>
                          <PlanrButton
                            style={{ marginLeft: "10px" }}
                            type="graybtn"
                            size="small"
                            onClick={() => {
                              this.setState({
                                showReturn: !this.state.showReturn,
                              })
                            }}
                          >
                            Отмена
                          </PlanrButton>
                        </div>
                      </div>
                    </Dialog>

                    <TransferDialog
                      isOpen={this.state.showChangePosition}
                      onClose={() => this.setState({ showChangePosition: false })}
                      employer={employer}
                      positions={Object.values(employerPositions)}
                      departments={departmentOptions}
                      portfolios={portfolios.portfolios.map((p) => ({ id: p.id, label: p.label }))}
                      canSalary={!!this.props.canSalary}
                    />






                    {
                      selectedDepartmentId !== "" && selectedDepartmentId !== gipDepartmentId && (
                        <StandardFormInput
                          name={fields.canBeEngineer}
                          schema={schema}
                          small={true}
                          className="planr-form-input"
                        >
                          {({ field }) => <Switch checked={field.value} {...field} large={true} disabled={!canChange} />}
                        </StandardFormInput>
                      )
                    }
                    <StandardFormInput name={fields.hireDate} schema={schema} small={true} className="planr-form-input">
                      {({ field, form }) => {
                        return (
                          <div className={`${Classes.INPUT_GROUP} `}>
                            <DatePicker
                              clasName="planr-default-input"
                              value={field.value}
                              onChange={(date) => {
                                form.setFieldValue(field.name, date)
                                form.setFieldTouched(field.name, true)
                              }}
                              disabled={!canChange}
                              small
                            />
                          </div>
                        )
                      }}
                    </StandardFormInput>
                    <StandardFormInput
                      name={fields.contractNumber}
                      schema={schema}
                      small={true}
                      className="planr-form-input"
                    >
                      {({ field }) => (
                        <InputGroup
                          id={field.name}
                          {...field}
                          className="planr-default-input"
                          autoComplete="off"
                          disabled={!canChange}
                          small
                        />
                      )}
                    </StandardFormInput>
                    <div className={styles.checkers}>
                      <StandardFormInput
                        name={fields.poohBah}
                        schema={schema}
                        small={true}
                        className="planr-form-input"
                      >
                        {({ field }) => <Switch checked={field.value} {...field} large={true} disabled={!canChange} />}
                      </StandardFormInput>

                      <StandardFormInput
                        name={fields.isBim}
                        schema={schema}
                        small={true}
                        style={{ marginLeft: "90px" }}
                        className="planr-form-input"
                      >
                        {({ field }) => (
                          <Switch
                            checked={field.value}
                            {...field}
                            large={true}
                            disabled={!canChange}
                            style={{ marginLeft: "-100px" }}
                          />
                        )}
                      </StandardFormInput>
                    </div>

                    <StandardFormInput
                      name={fields.workSince}
                      schema={schema}
                      small={true}
                      className="planr-form-input"
                      label="Стаж"
                    >
                      {() => {
                        return (
                          <InputGroup
                            value={seniorityText}
                            title={seniorityText}
                            className="planr-default-input"
                            autoComplete="off"
                            small
                            readOnly={true}
                          />
                        )
                      }}
                    </StandardFormInput>
                    <StandardFormInput name={fields.phone} schema={schema} small={true} className="planr-form-input">
                      {({ field }) => (
                        <InputGroup
                          id={field.name}
                          {...field}
                          className="planr-default-input"
                          small
                          autoComplete="off"
                          disabled={!canChange}
                        />
                      )}
                    </StandardFormInput>
                    <StandardFormInput name={fields.email} schema={schema} small={true} className="planr-form-input">
                      {({ field }) => (
                        <InputGroup
                          id={field.name}
                          {...field}
                          className="planr-default-input"
                          autoComplete="off"
                          small
                          disabled={!canChange}
                        />
                      )}
                    </StandardFormInput>
                    <StandardFormInput name={fields.address} schema={schema} small={true} className="planr-form-input">
                      {({ field }) => (
                        <InputGroup
                          id={field.name}
                          {...field}
                          className="planr-default-input"
                          small
                          autoComplete="off"
                          disabled={!canChange}
                        />
                      )}
                    </StandardFormInput>
                    <StandardFormInput name={fields.birthday} schema={schema} small={true} className="planr-form-input">
                      {({ field, form }) => {
                        return (
                          <div className={`${Classes.INPUT_GROUP} `}>
                            <DatePicker
                              clasName="planr-default-input"
                              value={field.value}
                              onChange={(date) => {
                                form.setFieldValue(field.name, date)
                                form.setFieldTouched(field.name, true)
                              }}
                              small
                              minDate={old}
                              disabled={!canChange}
                            />
                          </div>
                        )
                      }}
                    </StandardFormInput>

                    <StandardFormInput
                      name={fields.birthday}
                      schema={schema}
                      small={true}
                      className="planr-form-input"
                      label="Возраст"
                    >
                      {() => {
                        return (
                          <InputGroup
                            value={employer.agePeriod}
                            className="planr-default-input"
                            small
                            autoComplete="off"
                            readOnly={true}
                          />
                        )
                      }}
                    </StandardFormInput>
                    <StandardFormInput
                      name={fields.birthday}
                      schema={schema}
                      small={true}
                      className="planr-form-input"
                      label="Дети"
                    >
                      {() => (
                        <div style={{ display: "flex" }}>
                          <InputGroup
                            value={employer.childCount}
                            small
                            className="planr-default-input"
                            autoComplete="off"
                            readOnly={true}
                          />
                          <PlanrButton
                            size="small"
                            type="secondary"
                            onClick={this.toggleChildrenDialog}
                            style={{ marginLeft: "10px" }}
                          >
                            Список
                          </PlanrButton>
                        </div>
                      )}
                    </StandardFormInput>
                    <StandardFormInput name={fields.hobby} schema={schema} small={true} className="planr-form-input">
                      {({ field }) => (
                        <InputGroup
                          id={field.name}
                          {...field}
                          small
                          className="planr-default-input"
                          autoComplete="off"
                          disabled={!canChange}
                        />
                      )}
                    </StandardFormInput>
                    <StandardFormInput name={fields.signDateTo} schema={schema} small={true} className="planr-form-input">
                      {({ field, form }) => {
                        return (
                          <div className={`${Classes.INPUT_GROUP} `}>
                            <DatePicker
                              clasName="planr-default-input"
                              value={field.value}
                              onChange={(date) => {
                                form.setFieldValue(field.name, date)
                                form.setFieldTouched(field.name, true)
                              }}
                              small
                              minDate={old}
                              disabled={!canChange}
                            />
                          </div>
                        )
                      }}
                    </StandardFormInput>
                    <div className={styles.checkers}>
                      <StandardFormInput name={fields.fired} schema={schema} small={true} className="planr-form-input">
                        {({ field, form }) => (
                          <Switch
                            checked={field.value}
                            {...field}
                            large={true}
                            onChange={(e) => {
                              const newValue = !field.value
                              const unchecked = !newValue
                              if (this.isFired) {
                                this.setState({ showReturn: true })
                              }
                              field.onChange(e)
                              unchecked && form.setFieldValue(fields.fireDate, null)
                              unchecked && form.setFieldTouched(fields.fireDate, true)
                            }}
                            disabled={!canChange}
                          />
                        )}
                      </StandardFormInput>

                      <StandardFormInput
                        name={fields.canBeReturn}
                        schema={schema}
                        small={true}
                        className="planr-form-input"
                        label={<GeneralIcon type="general-boomerang" size={26}></GeneralIcon>}
                        style={{ marginLeft: "70px" }}
                      >
                        {({ field }) => (
                          <Switch
                            checked={field.value}
                            {...field}
                            large={true}
                            disabled={!canChange}
                            style={{ marginLeft: "-100px" }}
                          />
                        )}
                      </StandardFormInput>
                    </div>
                    {
                      getIn(values, fields.fired) && (
                        <StandardFormInput
                          name={fields.fireDate}
                          schema={schema}
                          label="Дата увольнения"
                          required={true}
                          small={true}
                          className="planr-form-input"
                        >
                          {({ field, form }) => {
                            return (
                              <div className={`${Classes.INPUT_GROUP} `}>
                                <DatePicker
                                  clasName="planr-default-input"
                                  value={field.value}
                                  onChange={(date) => {
                                    form.setFieldValue(field.name, date)
                                    form.setFieldTouched(field.name, true)
                                  }}
                                  small
                                  disabled={!canChange}
                                />
                              </div>
                            )
                          }}
                        </StandardFormInput>
                      )
                    }
                    <Divider style={{ marginTop: "-5px" }} />
                    <br />
                  </div>

                  <div className={styles.files}>
                    <Field name={fields.documentBlocks}>
                      {(fieldProps: FieldProps) => (
                        <EmployerDocuments
                          canChange={canChange}
                          employer={employer}
                          fieldProps={fieldProps}
                          baseUrl={baseUrl}
                          notes={documentNotes}
                        />
                      )}
                    </Field>
                  </div>

                  {!isNewEmployer && (
                    <div className={styles.projects}>
                      <OwnSpendingsWidget
                        store={spendings}
                        withSpendings={true}
                        collapsable={false}
                        orderAccess={orderAccess}
                        employeeList={employerList}
                        employerId={employerId}
                      />
                    </div>
                  )}
                  {isNewEmployer && (
                    <div className={styles.newEmployee}>
                      <StandardFormInput name={fields.salary} schema={schema} small={true} className="planr-form-input">
                        {({ field, form }) => (
                          <MoneyInput
                            className="planr-default-input"
                            id={field.name}
                            autoComplete="off"
                            data-lpignore="true"
                            value={field.value}
                            onMoneyChange={(money) => {
                              form.setFieldValue(field.name, money.value, true)
                            }}
                          />
                        )}
                      </StandardFormInput>

                      <StandardFormInput name={fields.bonus} schema={schema} small={true} className="planr-form-input">
                        {({ field, form }) => (
                          <MoneyInput
                            className="planr-default-input"
                            id={field.name}
                            autoComplete="off"
                            data-lpignore="true"
                            value={field.value}
                            onMoneyChange={(money) => {
                              form.setFieldValue(field.name, money.value, true)
                            }}
                          />
                        )}
                      </StandardFormInput>
                    </div>
                  )}
                </div>
                <div className={`${Classes.DIALOG_FOOTER} ${styles.footer}`}>
                  {canChange && (
                    <PlanrButton
                      type="lightblueish"
                      size="small"
                      className={styles.loginButton}
                      title="Логин, пароль и приглашение в приложение"
                      onClick={() => this.setState({ accessOpen: true })}
                    >
                      <span className={`${styles.loginDot} ${this.loginDotClass((values as any)[fields.newPassword])}`} />
                      Данные для входа
                    </PlanrButton>
                  )}
                  {canChange && (
                    <Dialog
                      isOpen={this.state.accessOpen}
                      onClose={() => this.setState({ accessOpen: false })}
                      title="Данные для входа"
                      className={`figma-dialog ${styles.accessDialog}`}
                      backdropClassName="standard"
                    >
                      <div className={Classes.DIALOG_BODY}>
                          {canChange && (
                            <AccessBlock
                              loginField={fields.login}
                              passwordField={fields.newPassword}
                              accountId={employer.id}
                              isNew={isNewlyCreated(employer.id)}
                              canChange={canChange}
                              load={employer.loadAccess}
                              send={employer.sendAccessLink}
                              revoke={employer.revokeAccessLink}
                              generate={employer.getCredentials}
                              block={employer.blockAccess}
                              unblock={employer.unblockAccess}
                              mailCredentials={employer.mailCredentials}
                              afterSave={{ mailField: "mailCredentials", inviteField: "sendInvite", emailField: fields.email }}
                              onAccessChanged={() => employerList.load()}
                              className={styles.access}
                            />
                          )}
                      </div>
                      <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                          <PlanrButton type="graybtn" size="small" onClick={() => this.setState({ accessOpen: false })}>
                            Закрыть
                          </PlanrButton>
                          <PlanrButton
                            type="greenish"
                            size="small"
                            disabled={!dirty}
                            onClick={() => {
                              this.setState({ accessOpen: false })
                              formProps.submitForm()
                            }}
                          >
                            Сохранить
                          </PlanrButton>
                        </div>
                      </div>
                    </Dialog>
                  )}
                  {canChange && (
                    <div className={Classes.DIALOG_FOOTER_ACTIONS} >
                      <StandardFormButtons
                        {...formProps}
                        isRemoved={false}
                        what={`сотрудника ${employer.name}`}
                        isNewlyCreated={employer.isNewlyCreated}
                        onRemove={this.onRemove}
                      />
                    </div>
                  )}
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    )
  }

  toggleChildrenDialog = () => {
    this.setState({ showChildrenDialog: !this.state.showChildrenDialog })
  };

  toggleChild = () => {
    this.setState({ showChild: !this.state.showChild })
  };

  toggleAvatarLoad = () => {
    this.setState({ showAvatarLoad: !this.state.showAvatarLoad })
  };

  onRemove = async () => {
    if (!this.formProps) {
      return
    }

    this.formProps.setSubmitting(true)
    const success = await this.props.employer.delete()
    this.formProps.setSubmitting(false)
    success && this.props.onRemoved()
  };
}

export const EmployerDetails = observer(Employer)

interface EmployerDetailsProps {
  baseUrl: string
  canChange: boolean
  positions: EmployeePositionDictionaryType
  employer: EmployerType
  spendings: OwnSpendingsWidgetStoreType
  onSaved: (id: string) => void
  onRemoved: () => void
  onPrintCredentials: (employer: EmployerType) => void
  orderAccess: boolean
  employerList: EmployeeListType
  employerId: string
  portfolios: ProjectPortfolioDictionaryType
  /** примечания к документам, уже встречающиеся в базе — подсказки в блоках документов */
  documentNotes: string[]
  /** подразделения для поля «Подразделение»: подпись — путь в дереве структуры */
  departments?: { id: string; label: string }[]
  /** новый сотрудник из дерева структуры — сразу в это подразделение */
  presetDepartmentId?: string
  /** новый сотрудник на вакансию из дерева структуры — сразу на эту должность */
  presetPositionId?: string
  /** есть право смотреть справочник должностей (просмотр или правка структуры) */
  canOpenPositions?: boolean
  /** есть право на штатку: в переводе на должность видно и меняется оклад/премия */
  canSalary?: boolean
}

interface EmployerDetailsState {
  showChildrenDialog: boolean
  showChild: boolean
  showAvatarLoad: boolean
  showChangePosition: boolean
  /** открыта форма должности: "" — новая, иначе id */
  positionDialog: string | null
  /** открыт справочник должностей */
  positionsDictionary: boolean
  showReturn: boolean
  showGrades: boolean
  childId: string
  avatar: string
  gradeGuid: string | null
  /** открыто окно «Данные для входа» (логин, пароль, приглашение) */
  accessOpen: boolean
  accessStatus: AccessStatus | null
}

function buildDepartmentOptions(departments?: { id: string; label: string }[]): SelectItem[] {
  return (departments ?? []).map((d) => ({ id: d.id, label: d.label }))
}

function buildPositionsOptions(positions: EmployeePositionDictionaryType) {
  const result: TStringMap<PositionSelectItem> = {}

  // должность — справочник «кем работает», отдел в подписи больше не показываем
  positions.positions.forEach(({ id, label }) => {
    result[id] = { id, label, department: "" }
  })

  return result
}

function getFormValues(employer: EmployerType, presetDepartmentId = "", presetPositionId = "") {

  const currentGradeGuid = employer.employerPositions?.[0]?.gradeGuid || "null"
  // сырой documents в форму не берём: с ним работают блоки документов,
  // а в патч он попадать не должен
  const { documents, ...snapshot } = getSnapshot(employer)

  return {
    ...snapshot,
    [fields.phone]: employer.formattedPhone,
    [fields.workSince]: employer.workSinceAsDate,
    [fields.birthday]: employer.birthdayAsDate,
    [fields.signDateTo]: employer.signToAsDate,
    [fields.fireDate]: employer.fireDateAsDate,
    [fields.hireDate]: employer.hireDateAsDate,
    [fields.fired]: employer.fired,
    [fields.positionId]: employer.employePositionId || presetPositionId || employer.employePositionId,
    [fields.departmentId]: employer.department?.id || presetDepartmentId || "",
    [fields.documentBlocks]: employer.documentBlocksForm,
    [fields.salary]: 0,
    [fields.bonus]: 0,
    [fields.children]: employer.children,
    [fields.changeGrade]: currentGradeGuid,
    [fields.changeGradeSince]: null
  }
}

const SelectedPositionRenderer = ({ disabled, icon, text, option }: RendererProps) => {
  const item: PositionSelectItem | null | undefined = option as any

  return (
    <Button
      disabled={disabled}
      style={item?.department ? { height: "50px" } : undefined}
      fill={true}
      rightIcon={icon}
      className="selected-option"
      text={item?.department ? <EmployerName name={text} position={item.department} /> : text}
    />
  )
}

const PositionOptionRenderer: ItemRenderer<PositionSelectItem> = (item, { handleClick, modifiers }) => {
  if (!modifiers.matchesPredicate) {
    return null
  }

  const text = <EmployerName name={item.label} position={item.department} />

  return (
    <MenuItem
      active={modifiers.active}
      disabled={modifiers.disabled}
      key={item.id}
      onClick={handleClick}
      text={text}
      className={item.removed ? "removed" : ""}
    />
  )
}

const filterPositionPredicate: ItemPredicate<PositionSelectItem> = (query, item, _index, exactMatch) => {
  const normalizedQuery = query.toLowerCase().trim()

  if (exactMatch) {
    return item.label.toLowerCase() === normalizedQuery
  } else {
    const normalizedText = `${item.label} ${item.department}`.toLowerCase()
    return normalizedText.indexOf(normalizedQuery) >= 0
  }
}

interface PositionSelectItem extends SelectItem {
  department: string
}
